import { ListItemText, Stack } from '@mui/material';
import classNames from 'classnames';
import cn from 'classnames';
import { PopoverTrigger } from 'src/components/PopoverTrigger';
import useActiveLink from 'src/hooks/useActiveLink';
import Iconify from '../../../components/iconify';
import { NavActionButton } from '../NavActionButton/NavActionButton';
import { NavLink } from './NavLink';
import { MenuItemStyled, StyledIcon } from './styles';
import { NavItemProps } from './types';

export const NavItemDefault = <TPopoverProps extends object>({
  path,
  depth = 1,
  linkActiveMatchChildren,
  highlight,
  badgeContent,
  disabled,
  optionsPopover,
  optionsContext,
  children,
  navIcon,
  action,
  actionAlwaysVisible,
  icon,
  isTreeView,
  hasSubNav,
  isSubNavOpen,
  toggleSubNav,
  onClick,
  selected,
  connected,
  ...other
}: NavItemProps<TPopoverProps>) => {
  const { active, exact } = useActiveLink(path, linkActiveMatchChildren);

  const subItem = depth !== 1;

  return (
    <NavLink path={path} onClick={onClick}>
      <MenuItemStyled
        className={classNames({
          isSubActive: isSubNavOpen && active && !exact,
          selected,
          connected,
          isTreeView,
        })}
        depth={depth}
        selected={active}
        disabled={disabled}
        active={subItem}
        {...other}
      >
        {isTreeView && (
          <StyledIcon className={cn({ hidden: !hasSubNav })}>
            <Iconify
              className="navIcon"
              width={18}
              height={18}
              icon={
                isSubNavOpen
                  ? 'eva:arrow-ios-downward-fill'
                  : 'eva:arrow-ios-forward-fill'
              }
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                toggleSubNav?.();
              }}
            />
          </StyledIcon>
        )}

        {icon && <StyledIcon>{icon}</StyledIcon>}

        {typeof children === 'string' ? (
          <ListItemText
            primary={children}
            sx={{
              m: 0,
            }}
            primaryTypographyProps={{
              noWrap: true,
              variant: active ? 'subtitle2' : 'body2',
            }}
          />
        ) : (
          children
        )}

        {highlight && (
          <div className={classNames({ highlight: highlight })}>
            {(badgeContent || 0) > 9 ? '+9' : badgeContent}
          </div>
        )}
        {(optionsPopover || action || hasSubNav) && (
          <Stack direction="row" sx={{ ml: 'auto' }}>
            {optionsPopover && (
              <PopoverTrigger
                popover={optionsPopover}
                context={optionsContext}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                }}
              >
                <NavActionButton
                  icon="tabler:dots-vertical"
                  size={16}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                  }}
                />
              </PopoverTrigger>
            )}

            {action && (
              <div className={classNames({ hoverOnly: !actionAlwaysVisible })}>
                {action}
              </div>
            )}
          </Stack>
        )}
      </MenuItemStyled>
    </NavLink>
  );
};
